import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { IconButton, ButtonGroup, ButtonProps, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { User } from "../../User";
import { userRemoved } from "../../../../actions/usersActions";
import { useOrgManager } from "../../../../providers/OrgManagerProvider/OrgManagerProvider";
import useSnackbarNotifications from "../../../../hooks/useSnackbarNotifications";

const ActionsFormatter = (props: { user: User }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { writeService } = useOrgManager();
  const snackbar = useSnackbarNotifications();

  const handleEvent = (
    dispatchMessage: (user: User) => any,
    successMessage: string,
    event?: (user: User) => Promise<User>
  ) => {
    if (!event) return;

    console.log("writeService: ", writeService);

    event(props.user)
      .then((res: User) => {
        dispatch(dispatchMessage(res));
        snackbar.success(successMessage);
      })
      .catch((e: any) => {
        console.error("Failed to broadcast transaction: ", e);
        snackbar.error(
          t("messages.keeper.broadcastFailed", {
            message: e.message,
          })
        );
      });
  };

  const handleDelete = (): void => {
    return handleEvent(
      userRemoved,
      t("messages.users.userDeleted"),
      writeService?.removeUser
    );
  };

  const renderButton = (
    variant: ButtonProps["color"],
    text: string,
    onClick: () => void,
    key: string
  ) => {
    return (
      <Tooltip title={text} key={key}>
        <IconButton color={variant as any} onClick={onClick}>
          <Delete />
        </IconButton>
      </Tooltip>
    );
  };

  const buttons: JSX.Element[] = [];

  buttons.push(
    renderButton("error", t("buttons.users.delete"), handleDelete, "delete")
  );

  return <ButtonGroup size="small">{buttons}</ButtonGroup>;
};

export default ActionsFormatter;
